module.exports = __webpack_public_path__ + "img/mayBanner_320.880f07d6.png";